<app-exam-header [pageTitle]="blog.title"></app-exam-header>
<div class="page-content">

    <!-- Blog Details -->
    <section>
        <div class="container">
            <div class="row">
                <div class="col-lg-9 blog-right-col">
                    <div class="row">
                        <div class="col-md-12">
                            <article class="post blog-details">
                                <div class="blog-classic">
                                    <div class="pbmit-featured-img-wrapper">
                                        <!-- New Date Badge -->
                                        <div class="date-badge">
                                            <span class="date-day">{{blog.blog_date | date:'dd'}}</span>
                                            <div class="date-divider"></div>
                                            <div class="date-month-year">
                                                <span class="date-month">{{blog.blog_date | date:'MMM'}}</span>
                                                <span class="date-year">{{blog.blog_date | date:'yyyy'}}</span>
                                            </div>
                                        </div>
                                        <div class="pbmit-featured-wrapper">
                                            <img [src]="siteUrl + 'api/static' + blog.image" class="img-fluid w-100" alt="">
                                        </div>
                                    </div>
                                    <div class="pbmit-blog-classic-inner" [innerHTML]="blog.description"></div>
                                </div>
                            </article>
                            <div class="comments">
                                <h2 class="widget-title">Write your comments</h2>
                                <div class="comments-list" *ngIf="comments.length > 0">
                                    <h3 class="comments-title">Comments ({{comments.length}})</h3>
                                    <div class="comments-box">
                                        <div class="comment-item" *ngFor="let comment of comments; let last = last">
                                            <strong class="comment-username">{{comment.name}}</strong>
                                            <p class="comment-text">{{comment.answer}}</p>
                                            <!-- <small class="comment-email">{{comment.email}}</small> -->
                                            <hr *ngIf="!last && comments.length > 2">
                                        </div>
                                    </div>
                                </div>
                                <div class="comment-form">
                                    <!-- <input type="text" placeholder="Your Name" [(ngModel)]="commentName" class="form-control mb-2">
                                    <input type="email" placeholder="Your Email" [(ngModel)]="commentEmail" class="form-control mb-2"> -->
                                    <textarea rows="4" placeholder="Write your comments here" [(ngModel)]="newComment" class="form-control mb-2"></textarea>
                                    <i class="fa fa-paper-plane" aria-hidden="true" (click)="addComment()"></i>
                                </div>
                            </div>
                        </div>
                        <!-- Comments Section -->
                    </div>
                </div>
                <div class="col-lg-3 blog-left-col">
                    <aside class="sidebar">
                        <!-- Recent Blogs -->
                        <aside class="widget widget-recent-post">
                            <h2 class="widget-title">Recent Blogs</h2>
                            <ul class="recent-post-list">
                                <li class="recent-post-list-li" *ngFor="let blog of recentBlogs">
                                    <a class="recent-post-thum" href="blog/{{blog.id}}">
                                        <img [src]="siteUrl + 'api/static' + blog.image" class="img-fluid w-100" alt="">
                                    </a>
                                    <div class="media-body">
                                        <span class="post-title">
                                            <a href="blog/{{blog.id}}">{{blog.title}}</a>
                                        </span>
                                        <span class="post-date">
                                            <a>{{blog.blog_date | date:'MMM d, yyyy'}}</a>
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </aside>
                        <!-- Categories -->
                        <!-- <aside class="widget widget-categories">
                            <h2 class="widget-title">Categories</h2>
                            <ul>
                                <li *ngFor="let category of categoryList">
                                    <a href="/blogs">
                                        <div style="color: black;">{{category}}</div>
                                    </a>
                                    <span>{{categories[category]}}</span>
                                </li>
                            </ul>
                        </aside> -->
                    </aside>
                </div>
            </div>
        </div>
    </section>
    <!-- Blog Details End -->

</div>
<app-exam-footer></app-exam-footer>